import type { User } from '../../types/schema';
import { LOCAL_STORAGE_KEYS } from '../../utils/constants';
import type { BriefingTopic } from './dailyBriefingData';
import { getConfirmationStats, getTodayDateKey } from './dailyBriefingData';

function autoShownStorageKey(companyId: string, userId: string): string {
    return `${LOCAL_STORAGE_KEYS.DAILY_BRIEFING_AUTO_SHOWN}:${companyId}:${userId}`;
}

/** Whether the Home auto-launch overlay was already shown for this user/company on the local date. */
export function hasAutoShownDailyBrief(
    userId: string,
    companyId: string,
    todayKey = getTodayDateKey(),
): boolean {
    try {
        return localStorage.getItem(autoShownStorageKey(companyId, userId)) === todayKey;
    } catch {
        return false;
    }
}

/** Persist that the Home auto-launch overlay was shown for this local date. */
export function setAutoShownDailyBrief(
    userId: string,
    companyId: string,
    todayKey = getTodayDateKey(),
): void {
    try {
        localStorage.setItem(autoShownStorageKey(companyId, userId), todayKey);
    } catch {
        // ignore quota / private mode
    }
}

export function shouldAutoLaunchDailyBrief(params: {
    topic: BriefingTopic | null;
    user: User | null | undefined;
    companyId: string | null | undefined;
}): boolean {
    const { topic, user, companyId } = params;
    if (!topic || !user?.id || !companyId) return false;
    if (hasAutoShownDailyBrief(user.id, companyId)) return false;
    const { confirmedCount } = getConfirmationStats([user], topic.id);
    if (confirmedCount > 0) return false;
    return true;
}
